import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propertyNormalizer'
})
export class PropertyNormalizerPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var normalizedParams = {};
    for (var i in value) {
      if (value.hasOwnProperty(i)) {
        normalizedParams[i.toLowerCase()] = value[i];
      }
    }
    return normalizedParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/property-normalizer.pipe.ts